import { Grid, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import { Alert, Form } from "../../../layout";
import { Button, FormErrorSummary, InputPass } from "../../../controls";
import { Model, UseForm, useValidationSummary } from "../../../hooks";
import { PassValidation } from "../../../utils";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ChangePass = (props) => {
  const { setActiveStep, setForgotVal, forgotVal } = props;
  const { ForgotMdl } = Model();
  const navigate = useNavigate();
  const { t } = useTranslation(["common", "validation"]);
  const [err] = useState();
  const [loading, setLoading] = useState(false);
  const { values, setValues, errors, setErrors, handleInpPass, passValid } =
    UseForm(ForgotMdl);
  const { onInvalid, reset, summaryProps } = useValidationSummary({ errors });
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  const validateForm = () => {
    let temp = {};
    temp.password = values.password !== "" ? "" : t("validation:passwordRequired");
    temp.confirmPass =
      values.confirmPass !== ""
        ? values.confirmPass === values.password
          ? ""
          : t("validation:passwordNotMatch")
        : t("validation:confirmPasswordRequired");
    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const submitForm = (e) => {
    e.preventDefault();
    if (validateForm()) {
      reset();
      setLoading(false);
      navigate("/dashboard");
      values.forgotStep = 3;
    } else onInvalid();
  };

  useEffect(() => {
    setValues(forgotVal);
    return () => {
      setValues();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    setForgotVal({ ...values });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  return (
    <>
      <Form noValidate onSubmit={submitForm}>
        <Grid container className="p-[10px] pt-0" spacing={2}>
          <Grid item xs={12} className="tx-center !mt-[30px] pb-[30px]">
            <h2 className="text-[22px] font-medium uppercase text-gray-500">
              {t("changePassword")}
            </h2>
            <div className="relative flex justify-center">
              <div className="border-bottom w-[60px]" />
            </div>
          </Grid>
          {summaryProps.visible && (
            <Grid item xs={12}>
              <FormErrorSummary {...summaryProps} />
            </Grid>
          )}
          {err && (
            <Grid item xs={12}>
              <Typography variant="subtitle1" color="error">
                <span className="font-medium uppercase"> {t("error")}:&nbsp;</span>{" "}
                {err}
              </Typography>
            </Grid>
          )}
          <Grid item xs={12}>
            <InputPass
              label={t("password")}
              name="password"
              value={values.password}
              onChange={handleInpPass}
              error={errors.password}
              className="input-primary w-full"
            />
            <PassValidation {...{ password: values.password, passValid }} />
          </Grid>
          <Grid item xs={12}>
            <InputPass
              label={t("confirmPassword")}
              name="confirmPass"
              value={values.confirmPass}
              onChange={(e) => handleInpPass(e, true)}
              error={errors.confirmPass}
              className="input-primary w-full"
            />
          </Grid>
          <Grid item xs={12} className="text-center !mt-[20px]">
            <Button
              type="submit"
              loading={loading}
              size="large"
              className="w-full"
            >
              {t("changePassword")}
            </Button>
          </Grid>
        </Grid>
      </Form>
      <Alert
        onClick={() => setActiveStep(undefined)}
        alert={alert}
        setAlert={setAlert}
      />
    </>
  );
};

export default ChangePass;
